<template>
  <v-flex xs12 sm6 d-flex>
    <v-select :items="brands" label="Bandeira" v-model="cardBrand"
    item-text="title" item-value="business" return-object prepend-icon="credit_card" ></v-select>
  </v-flex>
</template>
<script>
import { mapGetters } from 'vuex';
import * as business from '@/helpers/business';

export default {
  name: 'CardBrand',
  computed: {
    cardBrand: {
      get() { return this.model; },
      set(newCardBrand) {
        this.$store.dispatch('payments/setCardBrand', newCardBrand.business);
        this.model;
      },
    },
    ...mapGetters({
      model: 'payments/filtersCardBrand',
    }),
  },
  data: () => ({
    brands: [
      { title: 'Visa', business: business.CARD_BRAND_VISA },
      { title: 'Visa Electron', business: business.CARD_BRAND_VISA_ELECTRON },
      { title: 'MasterCard', business: business.CARD_BRAND_MASTERCARD },
      { title: 'Hipercard', business: business.CARD_BRAND_HIPERCARD },
      { title: 'Elo', business: business.CARD_BRAND_ELO },
      { title: 'Elo Débito', business: business.CARD_BRAND_ELO_DEBIT },
      { title: 'Maestro', business: business.CARD_BRAND_MAESTRO },
      { title: 'Amex', business: business.CARD_BRAND_AMEX },
    ],
  }),
};
</script>








